<template>
  <div>
    <NuxtLink
      :to="blogPostUrl"
      class="block w-full"
      :aria-label="blog.currentTranslation?.title"
    >
      <UiLazyImg
        class="aspect-[360/450]"
        :cover="true"
        :alt="image?.alt || blog.currentTranslation?.title || $t('image')"
        :src="image?.file?.url || '/images/no-image.webp'"
      />
    </NuxtLink>
    <div class="px-3 sm:px-2 pt-4 pb-8">
      <PagesBlogTag
        v-if="blogPostCategory?.currentTranslation?.title"
        :tag="blogPostCategory?.currentTranslation?.title"
        color="white"
        class="mb-4"
      />
      <div class="mb-2">
        <NuxtLink
          class="ui-text-sm uppercase font-medium text-white"
          :to="blogPostUrl"
        >
          {{ blog.currentTranslation?.title }}
        </NuxtLink>
      </div>
      <div
        v-if="blog.currentTranslation?.short_description"
        class="ui-text-xs text-white"
        v-html="blog.currentTranslation?.short_description"
      />
      <div v-if="blogPostUrl" class="mt-2">
        <NuxtLink
          class="ui-text-xs text-white capitalize underline hover:no-underline underline-offset-2"
          :to="blogPostUrl"
        >
          {{ $t("readMore") }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Blog } from "ecom-types";

const props = defineProps<{
  blog: Blog;
}>();

const localePath = useLocalePath();

const image = computed(
  () => props.blog?.medias?.find((el) => el.position === "list") || null,
);

const blogPostCategory = computed(() => props.blog?.categories?.[0]);

const blogPostUrl = computed(() =>
  props.blog?.slug
    ? localePath(
        `/blog/${blogPostCategory.value?.slug || "all"}/${props.blog.slug}`,
      )
    : undefined,
);
</script>
